import React, { useState, useEffect } from "react";
import i18n from "i18next";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { FormProvider, useForm } from "react-hook-form";
import moment from "moment";
import WarehouseProjectUploadView from "./WarehouseProjectUploadView";
import { useSelector, useDispatch } from "react-redux";
import {
  activityType,
  ACTIVITY_GROUP,
  add,
  dateConfig,
  edit,
  SET_EMPTY as EMPTY,
} from "../../config/index";
import { getActivityGroups, getJobFamilies } from "../../redux/actions/appActions";
import { getActivityGroupByLanguage } from "../../utils/punch";
export const WarehouseProjectUploadContainer = () => {
  const methods = useForm({
    mode: "all",
  });
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const appConfig = useSelector((state) => state.appConfig);
  const user = useSelector((state) => state.user);
  const loggedInSupervisor = user.auth.user;
  const dispatch = useDispatch();
  const [name, setName] = useState(EMPTY);
  const [type, setType] = useState(-1);
  const [startDate, setStartDate] = useState(null);
  const [startDateErr, setStartDateErr] = useState(false);
  const [startDateErrMsg, setStartDateErrMsg] = useState(EMPTY);
  const [endDate, setEndDate] = useState(null);
  const [endDateErr, setEndDateErr] = useState(false);
  const [endDateErrMsg, setEndDateErrMsg] = useState(EMPTY);
  const [isActive, setIsActive] = useState(true);
  const [isJobFamilyRestricted, setIsJobFamilyRestricted] = useState(false);
  const [jobFamily, setJobFamily] = useState([]);
  const [pageTitle, setPageTitle] = useState(EMPTY);
  const [disableSave, setDisableSave] = useState(true);
  const [mode, setMode] = useState(add);
  const [loading, setLoading] = useState(false);
  const [backendErr, setBackendErr] = useState(false);
  const [success, setSuccess] = useState(false);
  const [nameErr, setNameErr] = useState(false);
  const [nameErrMsg, setNameErrMsg] = useState(EMPTY);
  let activityGroupOptions = getActivityGroupByLanguage(
    i18n.language,
    ACTIVITY_GROUP
  );
  const defaultAG = [{ label: t("general.select4"), value: -1 }];
  const [activityDetails, setActivityDetails] = useState(location.state);
  const [confirmationMsg, setConfirmationMsg] = useState(EMPTY);
  const [isDistrictRestricted, setIsDistrictRestricted] = useState(false);
  const [restrictedDistricts, setRestrictedDistricts] = useState([]);
  // console.log("activityDetails :", activityDetails);

  // declarations over

  // get all drop-down values from back end
  try {
    if (appConfig !== null && appConfig.activityGroups !== null) {
      activityGroupOptions = getActivityGroupByLanguage(
        i18n.language,
        appConfig.activityGroups
      );
      activityGroupOptions = defaultAG.concat(activityGroupOptions.filter(item=>item.isDetailsEnabled));
    }
  } catch (error) {
    console.warn("error in appconfig setting default", appConfig);
    activityGroupOptions = getActivityGroupByLanguage(
      i18n.language,
      ACTIVITY_GROUP
    ); // setting defaults
  }

 

 

  useEffect(() => {
    if (appConfig != null && appConfig.activityGroups == null) {
      dispatch(getActivityGroups());
    }
    if (appConfig != null && appConfig.jobFamilies == null) {
      dispatch(getJobFamilies());
    }

  }, []);

  
  return (
    <FormProvider {...methods}>
    <WarehouseProjectUploadView></WarehouseProjectUploadView>
    </FormProvider>
    
  );
};

export default WarehouseProjectUploadContainer;
